import { useConfigPortalCredentials } from "@src/presentation/providers/config/ConfigPortalCredentialsDataProvider";
import { ConfigListFooter } from "./ConfigListFooter";

export const ConfigPortalCredentialsFooter = () => {
  const { total, page, limit, loading, setPage } = useConfigPortalCredentials();

  return (
    <ConfigListFooter
      total={total}
      page={page}
      limit={limit}
      loading={loading}
      onPageChange={setPage}
      ariaLabel="Portal Credentials Pagination"
    />
  );
};
